/** Deterministic, platform-independent RNG utilities for terrain generation.
 *  cyrb128 hash → sfc32 PRNG. */

function cyrb128(str: string): [number, number, number, number] {
	let h1 = 1779033703, h2 = 3144134277, h3 = 1013904242, h4 = 2773480762;
	for (let i = 0; i < str.length; i++) {
		const k = str.charCodeAt(i);
		h1 = h2 ^ Math.imul(h1 ^ k, 597399067);
		h2 = h3 ^ Math.imul(h2 ^ k, 2869860233);
		h3 = h4 ^ Math.imul(h3 ^ k, 951274213);
		h4 = h1 ^ Math.imul(h4 ^ k, 2716044179);
	}
	h1 = Math.imul(h3 ^ (h1 >>> 18), 597399067);
	h2 = Math.imul(h4 ^ (h2 >>> 22), 2869860233);
	h3 = Math.imul(h1 ^ (h3 >>> 17), 951274213);
	h4 = Math.imul(h2 ^ (h4 >>> 19), 2716044179);
	return [(h1^h2^h3^h4)>>>0, (h2^h1)>>>0, (h3^h2)>>>0, (h4^h3)>>>0];
}

/** Returns a number between 0 (inclusive) and 1 (exclusive). */
function sfc32(a: number, b: number, c: number, d: number): ()=>number {
	return ()=>{
		a |= 0; b |= 0; c |= 0; d |= 0;
		const t = (a + b | 0) + d | 0;
		d = d + 1 | 0;
		a = b ^ b >>> 9;
		b = c + (c << 3) | 0;
		c = (c << 21 | c >>> 11);
		c = c + t | 0;
		return (t >>> 0) / 4294967296;
	};
}

/** Seeded RNG for a (worldSeed, isolineId, propName) triple — independent-but-deterministic
 *  streams. Stream names: "elevation", "crossingSlope", "influenceRadius", "shapeRoughness",
 *  "shapeWavelength", "shape", "summitPos", "summitProminence". */
export function rngStream(worldSeed: number, isolineId: string, propName: string): ()=>number {
	const seed = cyrb128(`${worldSeed}:${isolineId}:${propName}`);
	return sfc32(seed[0], seed[1], seed[2], seed[3]);
}

/** Seeded RNG for a (pathId, propName) pair — non-isoline paths whose shape randomness
 *  doesn't depend on the terrain world seed. */
export function rngStreamPath(pathId: string, propName: string): ()=>number {
	const seed = cyrb128(`${pathId}:${propName}`);
	return sfc32(seed[0], seed[1], seed[2], seed[3]);
}
